
define('ldsh!modules/editor/templates/edit_element_popup_header', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<ul class="ed-tabs">\n</ul>\n<div style="float:right;">\n  <a class="helpLink" href="javascript:void(0)" data-i18n="[href]editor.propertyGroups.helpURL" target="_blank">\n    <span data-i18n="includeEditor.help"></span>\n  </a>\n<b class="ed-c-btn ed-c-btn-default ed-overlay-close js-close">\n  <span class="ed-icon ed-icon-close"></span>\n</b>\n</div>\n';

}
return __p
};});

